import { ServiceProvider } from "Service";
import { Page } from "./Page";

export class MainPage extends Page {
    private view: kendo.View;

    constructor(serviceProvider: ServiceProvider) {
        super(serviceProvider);
    }

    async render(layout: kendo.Layout): Promise<void> {
        await this.initialize("main");

        await super.render(layout);

        this.view = new kendo.View(
            `<div class="dms-mapping-wrapper">
                <div data-bind="html: getTextBlockpageDescription" class="dms-textblock mt-1"></div>
            </div>`,
            {
                model: this.viewModel,
                evalTemplate: true,
                wrap: false,
                hide: () => {},
            }
        );

        layout.showIn(".dms-content-container", this.view);
    }

    dispose(): void {
        super.dispose();

        if (this.view) {
            this.view.destroy();
        }
    }
}
